import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
  isPending: boolean;
};

function AlertButtons(p: Props): ReactNode {
  return (
    <div className="flex items-center justify-end gap-sm">
      <Button variant="ghost" size="sm" onClick={p.onCancel}>
        Cancelar
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={p.onConfirm}
        disabled={p.isPending}
      >
        Alertar
      </Button>
    </div>
  );
}

export function CreatorAlertConfirm(p: Props): ReactNode {
  return (
    <div className="flex flex-col gap-sm border-t border-white/[0.06] pt-base">
      <p className="text-xs text-text-secondary">
        El collector verá este creador marcado al principio de su lista para
        revisar, editar o eliminar.
      </p>
      <AlertButtons {...p} />
    </div>
  );
}
